import {
  EuiText,
  EuiFlexGroup,
  EuiFlexItem,
  EuiButton,
  EuiCard
} from "@elastic/eui";
import { SearchkitHit } from "@searchkit/sdk/lib/esm";
import { useContext } from "react";
import { MapContext } from "./maps/MapContext";
import { useTranslation } from 'react-i18next';

export function HitCard({ hit }: { hit: SearchkitHit }) {
  const {setPopup}=useContext(MapContext);
  const { t } = useTranslation();
  return (
    <EuiCard
      onClick={() => setPopup(hit)}
      title={hit.fields.city + " - " + Math.round(hit.fields.usable_are) + "m2"}
      description=""
      footer={
        <div>
          <EuiButton
            disabled={hit.fields.sellerId != null}
            onClick={() =>
              (location.href = "/ElasticSearch/ClaimMyRoof?elRoofId=" + hit.id)
            }
            iconType="crosshairs"
          >
            Moj krov
          </EuiButton>
          <EuiButton
            onClick={() =>
              (location.href =
                "/ElasticSearch/SendOfferForRoof?elRoofId=" + hit.id)
            }
            iconType="bell"
          >
            Interesira me
          </EuiButton>
        </div>
      }
    >
      <EuiFlexItem key={hit.id}>
        <EuiFlexGroup gutterSize="m">
          <EuiFlexItem>
            <EuiFlexGroup justifyContent="spaceAround">
              <EuiFlexItem grow={false}>
                <EuiText textAlign="left">
                  <p>
                    <span>
                      <b>{t('Area')}: </b>
                      {Math.round(hit.fields.usable_are) + "m2"}
                    </span>
                    <br />
                    <span>
                      <b>Pogodnost: </b>
                      {hit.fields.suitabilit}
                    </span>
                    <br />
                    <span>
                      {hit.fields.note!=null ? <b>{t('Note')}: </b> :'' }        
                      {hit.fields.note}
                    </span>
                    <br />
                  </p>
                </EuiText>
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </EuiCard>
  );
}
